import { ScanBarcode, Twitter, Linkedin, Github, Instagram } from 'lucide-react';

const footerLinks = {
  Product: [
    { name: 'Features', href: '#features' },
    { name: 'Pricing', href: '#pricing' },
    { name: 'Partner Stores', href: '#' },
    { name: 'API for Developers', href: '#' },
    { name: 'Changelog', href: '#' },
  ],
  Company: [
    { name: 'About Us', href: '#' },
    { name: 'Blog', href: '#' },
    { name: 'Careers', href: '#' },
    { name: 'Press Kit', href: '#' },
    { name: 'Contact', href: '#contact' },
  ],
  'For Shoppers': [
    { name: 'Download App', href: '#' },
    { name: 'How it Works', href: '#how-it-works' },
    { name: 'Find Stores', href: '#' },
    { name: 'Help Center', href: '#' },
    { name: 'Rewards', href: '#' },
  ],
  'For Stores': [
    { name: 'Get Started', href: '#contact' },
    { name: 'Integration Guide', href: '#' },
    { name: 'Store Dashboard', href: '#' },
    { name: 'Support', href: '#' },
    { name: 'Success Stories', href: '#' },
  ],
};

const socialLinks = [
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Github, href: '#', label: 'GitHub' },
  { icon: Instagram, href: '#', label: 'Instagram' },
];

const Footer = () => {
  return (
    <footer className="bg-brand-secondary text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 lg:gap-12 mb-12">
          {/* Logo & Description */}
          <div className="col-span-2">
            <a href="#" className="flex items-center gap-2 mb-6" data-testid="footer-logo">
              <div className="w-10 h-10 bg-brand-primary rounded-xl flex items-center justify-center">
                <ScanBarcode className="w-6 h-6 text-white" />
              </div>
              <span className="font-heading font-black text-2xl text-white">
                Grab<span className="text-brand-primary">Pe</span>
              </span>
            </a>
            <p className="text-slate-400 leading-relaxed mb-6 max-w-xs">
              Scan products. Pay instantly. Skip the queue. The smarter way to shop in stores.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-brand-primary transition-colors"
                  aria-label={social.label}
                  data-testid={`social-${social.label.toLowerCase()}`}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-heading font-bold text-white mb-4">{category}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-slate-400 hover:text-white transition-colors text-sm"
                      data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* App Download */}
        <div className="border-t border-white/10 pt-8 mb-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <p className="text-slate-400">Get the app and start shopping smarter</p>
            <div className="flex items-center gap-4">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/200px-Download_on_the_App_Store_Badge.svg.png" 
                alt="Download on App Store" 
                className="h-10 opacity-80 hover:opacity-100 transition-opacity cursor-pointer"
              />
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/200px-Google_Play_Store_badge_EN.svg.png" 
                alt="Get it on Google Play" 
                className="h-10 opacity-80 hover:opacity-100 transition-opacity cursor-pointer"
              />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} GrabPe. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">Privacy Policy</a>
            <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">Terms of Service</a>
            <span className="text-slate-400 text-sm flex items-center gap-2">
              <span className="w-2 h-2 bg-functional-success rounded-full"></span>
              All systems operational
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
